import React, { useEffect, useState, useRef } from "react";
import {
  makeStyles,
  createStyles,
  withStyles,
  Theme,
} from "@material-ui/core/styles";
import { connect, ReactReduxContext } from "react-redux";
import moment from "moment";
import "moment-timezone";
import Grid from "@mui/material/Grid";
import {
  getReportTemplateParameter,
  createNewReport,
  updateReport,
  getUpdatedCustomerReportData,
  getAllergyPackage,
} from "../../../actions/LimsAdminActions";
import Loader from "../../../components/loader/index";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Select, MenuItem, TextField } from "@material-ui/core";
import "./index1.css";
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import { useNavigate } from "react-router-dom";
import qcCode from "../../../../qrcode.png";
import iso from "../../../../iso.png";
import Allergy_Report from "../AllergyReport/Allergyreport1.jpg";
import barcode from "../AllergyReport/barcode.png";
import Allergy_report1 from "../AllergyReport/allergy1.jpg";
import Allergy_new from "./allergy1.jpg";
import AllergyLogo from "../AllergyReport/allrgylogo.png";
import browserIcon from "../../../../browsericon.png";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";
import { Paper } from "@material-ui/core";
import { height } from "@mui/system";
const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      width: "100%",
    },
    centerIt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    fontWeight: {
      fontWeight: "bold",
    },
    textCenter: {
      textAlign: "center",
    },
    endIt: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    belowIt: {
      display: "flex",
      alignItems: "flex-end",
    },
    line: {
      borderBottom: "5px solid red",
      marginTop: "5px",
      width: "90%",
    },
    inputFiled: {
      outline: "none",
    },
    tableCell: {
      padding: 2,
      height: 50,
    },
    input: {
      padding: "1px",
    },
    // tableCell: {
    //     '&:nth-of-type(even)': {
    //       backgroundColor: '#f5f5f5',
    //     },
    //   },
  })
);
interface Props {
  reportListParameter: any;
  getReportTemplateParameter: any;
  bookingId: any;
  reportData: any;
  createNewReport: any;
  updateReport: any;
  getUpdatedCustomerReportData: any;
  getAllergyPackage: any;
  fetchAlleryReport: any;
}
const NbsReport: React.FC<Props> = ({
  getReportTemplateParameter,
  reportListParameter,
  bookingId,
  reportData,
  createNewReport,
  updateReport,
  getUpdatedCustomerReportData,
  getAllergyPackage,
  fetchAlleryReport,
}) => {
  const componentRef = useRef<any>(null);
  const timer = useRef<any>(0);
  const { id } = useParams<{ id: string }>();
  const classes = useStyles();
  const navigate = useNavigate();
  const { firstP, secondP, thirdP } = useParams<any>();
  const [status, setStatus] = useState<string>();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [loading, setLoading] = useState(false);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return (
      <button
        style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
      >
        Print Report
      </button>
    );
  }, []);

  //Parameter data

  const [paraCode, setParaCode] = useState<any>([]);

  useEffect(() => {
    const data: any = [];
    if (fetchAlleryReport && fetchAlleryReport?.length > 0) {
      fetchAlleryReport?.forEach((list: any) => {
        if (list.code) {
          // only push if the code field exists
          data.push(list.code);
        }
      });
    }
    setParaCode(data);
  }, [fetchAlleryReport]);

  //booking data
  const [alergyData, setAlergyData] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.booking &&
      reportListParameter?.booking.length > 0
    ) {
      reportListParameter?.booking?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setAlergyData(data);
  }, [reportListParameter]);

  // Vegitables
  const [vegitables, setVegitables] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.vegetables &&
      reportListParameter?.vegetables.length > 0
    ) {
      reportListParameter?.vegetables?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setVegitables(data);
  }, [reportListParameter]);

  const updatevegData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...vegitables];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setVegitables(storeData);
  };
  // fruits
  const [fruitsData, setFruitsData] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.fruits &&
      reportListParameter?.fruits.length > 0
    ) {
      reportListParameter?.fruits?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setFruitsData(data);
  }, [reportListParameter]);

  const updateFruitsData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...fruitsData];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setFruitsData(storeData);
  };
  // dryfruits
  const [dryfruitsData, setDryFruitsData] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.dryfruits &&
      reportListParameter?.dryfruits.length > 0
    ) {
      reportListParameter?.dryfruits?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setDryFruitsData(data);
  }, [reportListParameter]);

  const updateDryFruitData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...dryfruitsData];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setDryFruitsData(storeData);
  };
  //Spices
  const [spicesList, setSpicesList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.spices &&
      reportListParameter?.spices.length > 0
    ) {
      reportListParameter?.spices?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setSpicesList(data);
  }, [reportListParameter]);

  const updateSpicesData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...spicesList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setSpicesList(storeData);
  };

  //cereals
  const [cerealsList, setcerealsList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.cereals &&
      reportListParameter?.cereals.length > 0
    ) {
      reportListParameter?.cereals?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setcerealsList(data);
  }, [reportListParameter]);

  const updateCerealsData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...cerealsList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setcerealsList(storeData);
  };

  // Pulse
  const [pulse, setPulse] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.pulses &&
      reportListParameter?.pulses.length > 0
    ) {
      reportListParameter?.pulses?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setPulse(data);
  }, [reportListParameter]);

  const updatePulsesData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...pulse];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setPulse(storeData);
  };

  // seeds
  const [seeds, setSeeds] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.seeds_oil &&
      reportListParameter?.seeds_oil.length > 0
    ) {
      reportListParameter?.seeds_oil?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setSeeds(data);
  }, [reportListParameter]);

  const updateSeedsData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...seeds];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setSeeds(storeData);
  };

  //beverages
  const [beveragesList, setBeveragesList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.beverages &&
      reportListParameter?.beverages.length > 0
    ) {
      reportListParameter?.beverages?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setBeveragesList(data);
  }, [reportListParameter]);

  const updateBeveragesData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...beveragesList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setBeveragesList(storeData);
  };
  // dairy
  const [dairyList, setDairyList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.dairy &&
      reportListParameter?.dairy.length > 0
    ) {
      reportListParameter?.dairy?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setDairyList(data);
  }, [reportListParameter]);

  const updateDairyData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...dairyList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setDairyList(storeData);
  };

  //Others
  const [othersList, setOthersList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.others &&
      reportListParameter?.others.length > 0
    ) {
      reportListParameter?.others?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setOthersList(data);
  }, [reportListParameter]);

  const updateOthersData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...othersList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setOthersList(storeData);
  };

  //Seafoods
  const [seafoodsList, setSeafoodsList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.sea_food &&
      reportListParameter?.sea_food.length > 0
    ) {
      reportListParameter?.sea_food?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setSeafoodsList(data);
  }, [reportListParameter]);

  const updateSeaFoodData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...seafoodsList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setSeafoodsList(storeData);
  };

  // Meat
  const [meat, setMeat] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.meat &&
      reportListParameter?.meat.length > 0
    ) {
      reportListParameter?.meat?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setMeat(data);
  }, [reportListParameter]);

  const updateMeatData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...meat];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setMeat(storeData);
  };

  //animalsImg data
  const [animalsImg, setAnimalsImg] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.animals &&
      reportListParameter?.animals.length > 0
    ) {
      reportListParameter?.animals?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setAnimalsImg(data);
  }, [reportListParameter]);

  const updateAnimalsData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...animalsImg];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setAnimalsImg(storeData);
  };

  //grasses
  const [grassesList, setGrassesList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.grasses &&
      reportListParameter?.grasses.length > 0
    ) {
      reportListParameter?.grasses?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setGrassesList(data);
  }, [reportListParameter]);

  const updateGrassesData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...grassesList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setGrassesList(storeData);
  };

  //Insects
  const [insectsList, setInsectsList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.insects &&
      reportListParameter?.insects.length > 0
    ) {
      reportListParameter?.insects?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setInsectsList(data);
  }, [reportListParameter]);

  const updateInsectsData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...insectsList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setInsectsList(storeData);
  };

  //Weeds
  const [weedsList, setWeedsList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.weeds &&
      reportListParameter?.weeds.length > 0
    ) {
      reportListParameter?.weeds?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setWeedsList(data);
  }, [reportListParameter]);

  const updateWeedData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...weedsList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setWeedsList(storeData);
  };

  //dustmites
  const [dustmitesList, setDustmitesList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.dust_mites &&
      reportListParameter?.dust_mites.length > 0
    ) {
      reportListParameter?.dust_mites?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setDustmitesList(data);
  }, [reportListParameter]);

  const updateDustMitesData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...dustmitesList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setDustmitesList(storeData);
  };

  //mouldsList
  const [mouldsList, setMouldsList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.moulds_yeast &&
      reportListParameter?.moulds_yeast.length > 0
    ) {
      reportListParameter?.moulds_yeast?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setMouldsList(data);
  }, [reportListParameter]);

  const updateMouldsData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...mouldsList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setMouldsList(storeData);
  };

  // DUST
  const [dustList, setDustList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.dusts &&
      reportListParameter?.dusts.length > 0
    ) {
      reportListParameter?.dusts?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setDustList(data);
  }, [reportListParameter]);

  const updateDustData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...dustList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setDustList(storeData);
  };

  //Skin Contatct
  const [skinList, setSkinList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.skin_contact &&
      reportListParameter?.skin_contact.length > 0
    ) {
      reportListParameter?.skin_contact?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setSkinList(data);
  }, [reportListParameter]);

  const updateSkinData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...skinList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setSkinList(storeData);
  };

  // parasite
  const [parasiteList, setParasiteList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.parasite &&
      reportListParameter?.parasite.length > 0
    ) {
      reportListParameter?.parasite?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setParasiteList(data);
  }, [reportListParameter]);
  const updateParasiteData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...parasiteList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setParasiteList(storeData);
  };

  //ANTIBIOTICS
  const [antibioticsList, setAntibioticsList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.antibiotics &&
      reportListParameter?.antibiotics.length > 0
    ) {
      reportListParameter?.antibiotics?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setAntibioticsList(data);
  }, [reportListParameter]);

  const updateAntiBiotics = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...antibioticsList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setAntibioticsList(storeData);
  };

  //painKiller
  const [painKillerList, setPainKillerList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.painkiller &&
      reportListParameter?.painkiller.length > 0
    ) {
      reportListParameter?.painkiller?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setPainKillerList(data);
  }, [reportListParameter]);

  const updatePainKillerData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...painKillerList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setPainKillerList(storeData);
  };

  //MULTIVITAMIN
  const [multivitaminList, setMultivitaminList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.multivitamin &&
      reportListParameter?.multivitamin.length > 0
    ) {
      reportListParameter?.multivitamin?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setMultivitaminList(data);
  }, [reportListParameter]);

  const updateMultiVitamin = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...multivitaminList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setMultivitaminList(storeData);
  };

  //ANESTHESIA
  const [anesthesiaList, setAnesthesiaList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.anesthesia &&
      reportListParameter?.anesthesia.length > 0
    ) {
      reportListParameter?.anesthesia?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setAnesthesiaList(data);
  }, [reportListParameter]);

  const updateAnesthesiaData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...anesthesiaList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setAnesthesiaList(storeData);
  };

  //Others1
  const [others1List, setOthers1List] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.others1 &&
      reportListParameter?.others1.length > 0
    ) {
      reportListParameter?.others1?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setOthers1List(data);
  }, [reportListParameter]);

  const updateOthers1 = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...others1List];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setOthers1List(storeData);
  };

  // Results
  const [resultsData, setResultsData] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.result_brca &&
      reportListParameter?.result_brca.length > 0
    ) {
      reportListParameter?.result_brca?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setResultsData(data);
  }, [reportListParameter]);

  const updateResults = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...resultsData];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setResultsData(storeData);
  };
  // Hospital Id

  const [HospitalId, setHospitalId] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.Hospital_Id &&
      reportListParameter?.Hospital_Id.length > 0
    ) {
      reportListParameter?.Hospital_Id?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setHospitalId(data);
  }, [reportListParameter]);

  const updateHospitalID = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...HospitalId];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setHospitalId(storeData);
  };

  // doctor list
  const [doctorList, setDoctorlist] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.doctor_list &&
      reportListParameter?.doctor_list.length > 0
    ) {
      reportListParameter?.doctor_list?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setDoctorlist(data);
  }, [reportListParameter]);

  const updateDoctorListValue = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...doctorList];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setDoctorlist(storeData);
  };

  useEffect(() => {
    if (thirdP !== "add") {
      getUpdatedCustomerReportData(
        `booking_id=${firstP}&template_id=${secondP}`
      );
    } else {
      getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
    }
  }, []);

  useEffect(() => {
    getAllergyPackage(`booking=${firstP}`);
  }, []);

  const route = `/dashboard/la/allergy-report/${firstP}/${secondP}/edit`;
  const submitData = async (e: any) => {
    setLoading(true);
    e.preventDefault();
    let storeData: any = [];

    if (vegitables.length > 0) {
      vegitables?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (fruitsData.length > 0) {
      fruitsData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (dryfruitsData.length > 0) {
      dryfruitsData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (spicesList.length > 0) {
      spicesList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (cerealsList.length > 0) {
      cerealsList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (pulse.length > 0) {
      pulse?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (seeds.length > 0) {
      seeds?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (beveragesList.length > 0) {
      beveragesList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (dairyList.length > 0) {
      dairyList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (othersList.length > 0) {
      othersList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (seafoodsList.length > 0) {
      seafoodsList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (meat.length > 0) {
      meat?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (animalsImg.length > 0) {
      animalsImg?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (grassesList.length > 0) {
      grassesList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (insectsList.length > 0) {
      insectsList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (weedsList.length > 0) {
      weedsList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (dustmitesList.length > 0) {
      dustmitesList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (mouldsList.length > 0) {
      mouldsList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (dustList.length > 0) {
      dustList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (skinList.length > 0) {
      skinList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (parasiteList.length > 0) {
      parasiteList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (antibioticsList.length > 0) {
      antibioticsList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (painKillerList.length > 0) {
      painKillerList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (multivitaminList.length > 0) {
      multivitaminList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (anesthesiaList.length > 0) {
      anesthesiaList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (others1List.length > 0) {
      others1List?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (resultsData.length > 0) {
      resultsData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (HospitalId.length > 0) {
      HospitalId?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (doctorList.length > 0) {
      doctorList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    const reportData = {
      template_id: secondP,
      booking_id: firstP,
      case_id: firstP,
      status: status,
      template_parameter: storeData,
    };
    const reportEditData = {
      template_id: secondP,
      booking_id: firstP,
      case_id: firstP,
      status: status,
      template_parameter: storeData,
    };
    if (thirdP === "add") {
      await createNewReport(reportData);
      navigate("/dashboard/la");
    } else if (thirdP === "edit") {
      await updateReport(reportListParameter?.id, reportEditData);
    }
    navigate(route);
    setLoading(false);
    getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`);
  };

  const [uhid, setuhid] = useState<any>([]);
  const [tempCode, setTempCode] = useState<any>([]);
  useEffect(() => {
    setuhid(reportListParameter?.uhid);
    setTempCode(reportListParameter?.template_code);
  }, [reportListParameter]);
  const documentTitle = `${
    alergyData[0]?.pk
  }_${alergyData[0]?.customer_name?.replace(
    /[\/\s-]/g,
    "_"
  )}_${uhid}_${tempCode}`;

  console.log(firstP, "firstPfirstPfirstP");

  // Reports created on/before 15 June 2026 keep the previous format
  // (Method: ECLIA and the full doctor signature list). Reports created
  // today (16 June 2026) and in the future use the updated format
  // (Method: Immunoturbidimetric and only the "Doctor_list_33" signature).
  const NEW_FORMAT_CUTOFF = "2026-06-16";
  const useNewReportFormat = moment
    .tz(reportListParameter?.created_at, "Asia/Kolkata")
    .isSameOrAfter(moment.tz(NEW_FORMAT_CUTOFF, "Asia/Kolkata"), "day");

  return (
    <div style={{ margin: "55px auto" }}>
      <div>
        <div style={{ height: "20px" }}>
          <div>
            {thirdP !== "add" && (
              <ReactToPrint
                content={reactToPrintContent}
                trigger={reactToPrintTrigger}
                documentTitle={documentTitle}
              />
            )}
          </div>
        </div>
        <div style={{ width: "200px", marginLeft: "780px" }}>
          <TextField
            id="outlined-select-currency"
            select
            variant="outlined"
            fullWidth
            className={classes.input}
            label="Select Report Type"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{ height: "30px" }}
          >
            <MenuItem value={"Draft"}>Draft</MenuItem>
            <MenuItem value={"Approved"}>Approved</MenuItem>
            <MenuItem value={"Hold"}>Hold</MenuItem>
            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
          </TextField>
        </div>
        <div
          style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}
        >
          <div>
            <button
              style={{
                background: "#142c96",
                color: "white",
                width: "100px",
                height: "40px",
                marginTop: "-10px",
              }}
              disabled={status === ""}
              onClick={submitData}
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      <div
        id="PAGE"
        ref={componentRef}
        style={{
          width: 1122,
          background: "#fff",
          position: "relative",
        }}
      >
        <div>
          <img
            src={
              "https://static-redcliffelabs.s3.amazonaws.com/media/gallary-file/None/27fcfc4e-2b57-4b3f-91e9-56b4bac62fdf.jpg"
            }
            alt="logo"
          />
          <div className="text-block">
            <h1 style={{ fontWeight: "bold" }}>
              {alergyData[0]?.packages[0]?.name}
            </h1>
          </div>
        </div>
        {/* <div>
                    <img src={"https://static-redcliffelabs.s3.amazonaws.com/media/gallary-file/None/27fcfc4e-2b57-4b3f-91e9-56b4bac62fdf.jpg"} alt="logo" />
                </div> */}
        {/* header section */}
        <div>
          <div style={{ padding: "20px" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                background: "#fff",
              }}
            >
              <div style={{ width: "80%", padding: 15 }}>
                <div
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "25px",
                    textAlign: "left",
                  }}
                >
                  LABORATORY REPORT
                </div>
              </div>
              <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                <h3>
                  <img src={logo} alt="logo" style={{ width: "180px" }} />
                </h3>
              </div>
            </div>
          </div>
        </div>
        <Grid
          container
          spacing={2}
          style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-40px" }}
          className="marginLeft-a"
        >
          <Grid item xs={12}>
            <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
              <Grid item xs={2}>
                Patient Name
              </Grid>
              <Grid item xs={8}>
                : {alergyData[0]?.designation}&nbsp;
                {alergyData[0]?.customer_name}
              </Grid>
            </div>
          </Grid>
          <Grid item xs={6} style={{ marginTop: "-25px" }}>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 5px" }}
              >
                <Grid item xs={4}>
                  Age/Gender
                </Grid>
                <Grid item xs={8}>
                  : {alergyData[0]?.customer_age}Y/
                  {alergyData[0]?.customer_gender}
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 5px" }}
              >
                <Grid item xs={4}>
                  Patient ID/UHID
                </Grid>
                <Grid item xs={8}>
                  : {alergyData[0]?.pk}
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 5px" }}
              >
                <Grid item xs={4}>
                  Referred By
                </Grid>
                <Grid item xs={8}>
                  : {alergyData[0]?.doctor_name}
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 5px" }}
              >
                <Grid item xs={4}>
                  Sample Type
                </Grid>
                <Grid item xs={8}>
                  : {alergyData[0]?.sample_type}
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 5px" }}
              >
                <Grid item xs={4}>
                  Barcode No
                </Grid>
                <Grid item xs={8}>
                  : {alergyData[0]?.barcode}
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              {alergyData[0]?.center?.name &&
              alergyData[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                <div
                  style={{ width: "100%", display: "flex", margin: "8px 5px" }}
                >
                  <Grid item xs={4.2}>
                    Hospital ID
                  </Grid>
                  <Grid item xs={8.5}>
                    :{" "}
                    {HospitalId?.map((list: any, index: number) => {
                      return (
                        <input
                          key={list?.id}
                          style={{
                            border: "none",
                            width: "96%",
                            background: "none",
                            fontWeight: "bold",
                          }}
                          value={list?.parameter_value}
                          onChange={(e: any) =>
                            updateHospitalID(
                              list?.id,
                              e.target.value,
                              index,
                              "free_text",
                              list
                            )
                          }
                        />
                      );
                    })}
                  </Grid>
                </div>
              ) : null}
            </Grid>
          </Grid>
          {/* rest half page---------------------------> */}
          <Grid item xs={6} style={{ marginTop: "-25px" }}>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 0px" }}
              >
                <Grid item xs={4}></Grid>
                <Grid item xs={8}></Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 0px" }}
              >
                <Grid item xs={4}>
                  Bill Date
                </Grid>
                <Grid item xs={8}>
                  : {alergyData[0]?.booking_date}
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 0px" }}
              >
                <Grid item xs={4}>
                  Sample Collected
                </Grid>
                <Grid item xs={8}>
                  : {alergyData[0]?.collection_date}
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 0px" }}
              >
                <Grid item xs={4}>
                  Sample Received
                </Grid>
                <Grid item xs={8}>
                  : {alergyData[0]?.pickup_date},
                  {alergyData[0]?.pickup_time?.slice(
                    0,
                    alergyData[0]?.pickup_time.indexOf(".")
                  )}
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 0px" }}
              >
                <Grid item xs={4}>
                  Report Date
                </Grid>
                <Grid item xs={8}>
                  :{" "}
                  {moment
                    .tz(Date.now(), "Asia/Kolkata")
                    .format("YYYY-MM-DD,HH:mm:ss")}
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{ width: "100%", display: "flex", margin: "8px 0px" }}
              >
                <Grid item xs={4}>
                  Report Status
                </Grid>
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    {reportListParameter?.status === "Approved" ? (
                      <Grid item xs={8}>
                        : Final Report
                      </Grid>
                    ) : (
                      <Grid item xs={8}>
                        : {alergyData[0]?.report_status}
                      </Grid>
                    )}
                  </>
                )}
              </div>
            </Grid>
          </Grid>
        </Grid>
        <div
          style={{
            width: "100%",
            display: "flex",
            margin: "10px 0px",
            textAlign: "start",
            marginTop: "8px",
          }}
        >
          <TableContainer
            style={{ borderRadius: "8px", marginTop: "5px" }}
            className="marginLeft-a"
          >
            <Table stickyHeader aria-label="simple">
              <TableHead style={{ backgroundColor: "#dcd7d7" }}>
                <TableRow>
                  <TableCell align="center">Test Name</TableCell>
                  <TableCell align="center">Result</TableCell>
                  <TableCell align="center">Unit</TableCell>
                  <TableCell align="center">Ref. Interval</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableCell align="center" className={classes.tableCell}>
                  <h6>Total-IgE</h6>
                  <p>Method: {useNewReportFormat ? "Immunoturbidimetric" : "ECLIA"}</p>
                </TableCell>
                <TableCell align="center" className={classes.tableCell}>
                  {resultsData?.map((list: any, index: number) => {
                    const parameterValue = list?.parameter_value;
                    return (
                      <input
                        style={{
                          border: "none",
                          textAlign: "center",
                          fontWeight: parameterValue > 100 ? "bold" : "normal",
                        }}
                        value={list?.parameter_value}
                        onChange={(e: any) =>
                          updateResults(
                            list?.id,
                            e.target.value,
                            index,
                            "free_text",
                            list
                          )
                        }
                      />
                    );
                  })}
                </TableCell>
                <TableCell align="center" className={classes.tableCell}>
                  <p>IU/mL</p>
                </TableCell>
                <TableCell align="center" className={classes.tableCell}>
                  <p>0.0 - 100.0</p>
                </TableCell>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div style={{ padding: "20" }} className="marginLeft-a">
          <div
            style={{
              color: "#fff",
              fontWeight: "bold",
              fontSize: "20px",
              borderRadius: "0px 10px",
              backgroundColor: "rgb(28, 78, 128)",
              width: "270px",
              height: "28px",
              textAlign: "center",
              borderRight: "4px solid #e00241",
            }}
            className="box-a"
          >
            Clinical Significance:
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              background: "#fff",
              padding: "20px",
            }}
          >
            The level of total IgE rises during childhood and reaches adult
            levels during the teens. IgE is the mediator of the allergic
            response. Patients with atopic disease, including allergic asthma,
            allergic rhinitis, and atopic dermatitis commonly have moderately
            elevated serum IgE levels. Total serum IgE levels may also be
            elevated in the presence of some clinical conditions that are not
            related to allergy. These clinical conditions include parasitic
            infections, immunodeficiency states, autoimmune diseases, Hodgkin's
            disease, bronchopulmonary aspergillosis, IgE myeloma, and Sezary
            syndrome.
          </div>
          <hr
            style={{
              backgroundColor: "black",
              marginRight: "10px",
              marginTop: "-10px",
            }}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              background: "#fff",
              padding: "20px",
              marginTop: "-16px",
            }}
          >
            Conditions of Reporting: All Lab results are subject to clinical
            interpretation by a qualified medical professional & This report is
            not subject to use for any medico-legal purpose.
          </div>
        </div>
        {[
          ...vegitables,
          ...fruitsData,
          ...dryfruitsData,
          ...spicesList,
          ...cerealsList,
          ...pulse,
          ...seeds,
          ...beveragesList,
          ...dairyList,
          ...othersList,
          ...seafoodsList,
          ...meat,
          ...animalsImg,
          ...grassesList,
          ...insectsList,
          ...weedsList,
          ...dustmitesList,
          ...mouldsList,
          ...dustList,
          ...skinList,
          ...parasiteList,
          ...antibioticsList,
          ...painKillerList,
          ...multivitaminList,
          ...anesthesiaList,
          ...others1List,
        ]
          .filter(
            (list) =>
              paraCode.includes(list?.parameter_code) &&
              parseFloat(list?.parameter_value) > 0.36
          )
          .sort(
            (a, b) =>
              parseFloat(b.parameter_value) - parseFloat(a.parameter_value)
          ).length === 0 && (
          <div
            style={{ padding: "20", marginTop: "3px" }}
            className="marginLeft-a"
          >
            <h6>
              Following Allergens (Abnormal Values) Require Special Attention
              and Precaution:NA
            </h6>
          </div>
        )}
        {[
          ...vegitables,
          ...fruitsData,
          ...dryfruitsData,
          ...spicesList,
          ...cerealsList,
          ...pulse,
          ...seeds,
          ...beveragesList,
          ...dairyList,
          ...othersList,
          ...seafoodsList,
          ...meat,
          ...animalsImg,
          ...grassesList,
          ...insectsList,
          ...weedsList,
          ...dustmitesList,
          ...mouldsList,
          ...dustList,
          ...skinList,
          ...parasiteList,
          ...antibioticsList,
          ...painKillerList,
          ...multivitaminList,
          ...anesthesiaList,
          ...others1List,
        ]
          .filter(
            (list) =>
              paraCode.includes(list?.parameter_code) &&
              parseFloat(list?.parameter_value) > 0.36
          )
          .sort(
            (a, b) =>
              parseFloat(b.parameter_value) - parseFloat(a.parameter_value)
          ).length > 0 && (
          <div
            style={{ padding: "20", marginTop: "3px" }}
            className="marginLeft-a"
          >
            <h6>
              Following Allergens (Abnormal Values) Require Special Attention
              and Precaution:
            </h6>
          </div>
        )}

        {/* results value  */}
        <div
          style={{
            width: "100%",
            textAlign: "left",
            overflow: "hidden",
            display: "flex",
            gap: "14px",
            minHeight: "480px",
            maxHeight: "480px",
          }}
        >
          <div
            style={{ width: "100%", textAlign: "left", display: "table-cell" }}
          >
            <div>
              <div className="parent-container marginLeft-a">
                {[
                  ...vegitables,
                  ...fruitsData,
                  ...dryfruitsData,
                  ...spicesList,
                  ...cerealsList,
                  ...pulse,
                  ...seeds,
                  ...beveragesList,
                  ...dairyList,
                  ...othersList,
                  ...seafoodsList,
                  ...meat,
                  ...animalsImg,
                  ...grassesList,
                  ...insectsList,
                  ...weedsList,
                  ...dustmitesList,
                  ...mouldsList,
                  ...dustList,
                  ...skinList,
                  ...parasiteList,
                  ...antibioticsList,
                  ...painKillerList,
                  ...multivitaminList,
                  ...anesthesiaList,
                  ...others1List,
                ]
                  .filter(
                    (list) =>
                      paraCode.includes(list?.parameter_code) &&
                      parseFloat(list?.parameter_value) > 0.36
                  )
                  .sort(
                    (a, b) =>
                      parseFloat(b.parameter_value) -
                      parseFloat(a.parameter_value)
                  ).length > 0 && (
                  <TableHead
                    style={{
                      backgroundColor: "#dcd7d7",
                      display: "inline-table",
                    }}
                  >
                    <TableRow>
                      <TableCell align="left">Image</TableCell>
                      <TableCell align="left">Name</TableCell>
                      <TableCell align="right">Value (IU/mL)</TableCell>
                    </TableRow>
                  </TableHead>
                )}
                {[
                  ...vegitables,
                  ...fruitsData,
                  ...dryfruitsData,
                  ...spicesList,
                  ...cerealsList,
                  ...pulse,
                  ...seeds,
                  ...beveragesList,
                  ...dairyList,
                  ...othersList,
                  ...seafoodsList,
                  ...meat,
                  ...animalsImg,
                  ...grassesList,
                  ...insectsList,
                  ...weedsList,
                  ...dustmitesList,
                  ...mouldsList,
                  ...dustList,
                  ...skinList,
                  ...parasiteList,
                  ...antibioticsList,
                  ...painKillerList,
                  ...multivitaminList,
                  ...anesthesiaList,
                  ...others1List,
                ]
                  .filter(
                    (list) =>
                      paraCode.includes(list?.parameter_code) &&
                      parseFloat(list?.parameter_value) > 0.36
                  )
                  .sort(
                    (a, b) =>
                      parseFloat(b.parameter_value) -
                      parseFloat(a.parameter_value)
                  ).length > 0 && (
                  <TableHead
                    style={{
                      backgroundColor: "#dcd7d7",
                      display: "inline-table",
                    }}
                  >
                    <TableRow>
                      <TableCell align="left">Image</TableCell>
                      <TableCell align="left">Name</TableCell>
                      <TableCell align="right">Value (IU/mL)</TableCell>
                    </TableRow>
                  </TableHead>
                )}
                {[
                  ...vegitables,
                  ...fruitsData,
                  ...dryfruitsData,
                  ...spicesList,
                  ...cerealsList,
                  ...pulse,
                  ...seeds,
                  ...beveragesList,
                  ...dairyList,
                  ...othersList,
                  ...seafoodsList,
                  ...meat,
                  ...animalsImg,
                  ...grassesList,
                  ...insectsList,
                  ...weedsList,
                  ...dustmitesList,
                  ...mouldsList,
                  ...dustList,
                  ...skinList,
                  ...parasiteList,
                  ...antibioticsList,
                  ...painKillerList,
                  ...multivitaminList,
                  ...anesthesiaList,
                  ...others1List,
                ]
                  .filter(
                    (list) =>
                      paraCode.includes(list?.parameter_code) &&
                      parseFloat(list?.parameter_value) > 0.36
                  )
                  .sort(
                    (a, b) =>
                      parseFloat(b.parameter_value) -
                      parseFloat(a.parameter_value)
                  ).length > 0 && (
                  <TableHead
                    style={{
                      backgroundColor: "#dcd7d7",
                      display: "inline-table",
                    }}
                  >
                    <TableRow>
                      <TableCell align="left">Image</TableCell>
                      <TableCell align="left">Name</TableCell>
                      <TableCell align="right">Value (IU/mL)</TableCell>
                    </TableRow>
                  </TableHead>
                )}
              </div>
              <div className="table-body parent-container marginLeft-a">
                {[
                  ...vegitables,
                  ...fruitsData,
                  ...dryfruitsData,
                  ...spicesList,
                  ...cerealsList,
                  ...pulse,
                  ...seeds,
                  ...beveragesList,
                  ...dairyList,
                  ...othersList,
                  ...seafoodsList,
                  ...meat,
                  ...animalsImg,
                  ...grassesList,
                  ...insectsList,
                  ...weedsList,
                  ...dustmitesList,
                  ...mouldsList,
                  ...dustList,
                  ...skinList,
                  ...parasiteList,
                  ...antibioticsList,
                  ...painKillerList,
                  ...multivitaminList,
                  ...anesthesiaList,
                  ...others1List,
                ]
                  .filter(
                    (list) =>
                      paraCode.includes(list?.parameter_code) &&
                      parseFloat(list?.parameter_value) > 0.36
                  )
                  .sort(
                    (a, b) =>
                      parseFloat(b.parameter_value) -
                      parseFloat(a.parameter_value)
                  )
                  .map((list: any, index: number) => {
                    return (
                      <div className="table-row">
                        <div
                          style={
                            list?.parameter_url
                              ? { visibility: "visible", textAlign: "center" }
                              : { visibility: "hidden" }
                          }
                        >
                          <img
                            alt="description of image"
                            className="image"
                            src={list?.parameter_url}
                            style={{ marginLeft: "15px" }}
                          />
                        </div>
                        <div
                          className="table-cell"
                          style={{ textAlign: "center", marginRight: "-100px" }}
                        >
                          {list?.parameter_name}
                        </div>
                        <div
                          className="table-cell"
                          style={{
                            textAlign: "right",
                            marginRight: "20px",
                            fontWeight: "bold",
                          }}
                        >
                          {list?.parameter_value}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
        {/* doctorlist  */}
        <div style={{ padding: "20" }}>
          <div style={{ padding: "20px" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                background: "#fff",
                marginTop: "-10px",
              }}
            >
              <div
                style={{ width: "65%", textAlign: "left", padding: 15 }}
              ></div>
              {doctorList
                ?.filter((list: any) =>
                  useNewReportFormat
                    ? list?.parameter_name === "Doctor_list_33"
                    : true
                )
                ?.map((list: any, index: number) => {
                  return (
                    <div
                      key={list?.id}
                      style={{ width: "35%", padding: 15, textAlign: "center" }}
                    >
                      <img
                        alt="description of image"
                        style={{ width: "100px", height: "40px" }}
                        src={
                          "https://static-redcliffelabs.s3.amazonaws.com/media/gallary-images/None/560dcf11-f7db-4b0f-8ec9-fbdc33b2bbda.jpeg"
                        }
                      />
                      <textarea
                        style={{
                          border: "none",
                          resize: "none",
                          textAlign: "center",
                        }}
                        rows={4}
                        cols={50}
                        value={list?.parameter_value}
                        onChange={(e) =>
                          updateDoctorListValue(
                            list?.id,
                            e.target.value,
                            index,
                            "free_text",
                            list
                          )
                        }
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        {/* footer area */}
        <div style={{ padding: "20px" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              background: "#fff",
            }}
          >
            <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
              <h3>
                <QRCode
                  value={`https://lead.redcliffelabs.com/verify-report/?booking=${alergyData[0]?.uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`}
                  size={115}
                />
              </h3>
            </div>
            <div
              style={{
                width: "85%",
                textAlign: "left",
                padding: 10,
                marginTop: "-3px",
              }}
            >
              {alergyData[0]?.booking_type === "b2b" ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "10px 0px",
                    marginTop: "9px",
                  }}
                >
                  <div style={{ width: "33%", marginLeft: 8 }}>
                    <img
                      src={callIcon}
                      alt="logo"
                      style={{ width: "20px", margin: "2px" }}
                    />{" "}
                    <span style={{ color: "red" }}>928-909-0609</span>
                  </div>
                  <div style={{ width: "33%", marginLeft: 8 }}>
                    <img
                      src={maillIcon}
                      alt="logo"
                      style={{ width: "20px", margin: "2px" }}
                    />
                    <span style={{ color: "red" }}>
                      ccsupport@redcliffelabs.com
                    </span>
                  </div>
                  <div style={{ width: "33%", marginLeft: 8 }}>
                    <img
                      src={browserIcon}
                      alt="logo"
                      style={{ width: "20px", margin: "2px" }}
                    />
                    <span style={{ color: "red" }}>www.redcliffelabs.com</span>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "10px 0px",
                    marginTop: "9px",
                  }}
                >
                  <div style={{ width: "33%", marginLeft: 8 }}>
                    <img
                      src={callIcon}
                      alt="logo"
                      style={{ width: "20px", margin: "2px" }}
                    />{" "}
                    <span style={{ color: "red" }}>898-898-0606</span>
                  </div>
                  <div style={{ width: "33%", marginLeft: 8 }}>
                    <img
                      src={maillIcon}
                      alt="logo"
                      style={{ width: "20px", margin: "2px" }}
                    />
                    <span style={{ color: "red" }}>care@redcliffelabs.com</span>
                  </div>
                  <div style={{ width: "33%", marginLeft: 8 }}>
                    <img
                      src={browserIcon}
                      alt="logo"
                      style={{ width: "20px", margin: "2px" }}
                    />
                    <span style={{ color: "red" }}>www.redcliffelabs.com</span>
                  </div>
                </div>
              )}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "left",
                  marginBottom: "-15px",
                }}
              >
                <h6 style={{ marginLeft: "16px" }}>
                  {" "}
                  Redcliffe Lifetech Private Limited, H-31, Sector-63, Noida,
                  Uttar Pradesh, 201301
                </h6>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  marginLeft: "16px",
                  textAlign: "left",
                }}
              >
                <p style={{ fontSize: "13px", marginTop: "3px" }}>
                  {" "}
                  All Lab are subjected to clinical interpretations by qualified
                  medical professional and this report is not subject to use for
                  any medico-legal purpose.
                </p>
              </div>
              <hr
                style={{
                  backgroundColor: "red",
                  width: "100%",
                  height: "8px",
                  marginTop: "10px",
                }}
              />
            </div>
          </div>
          {/* second page  */}
        </div>
        {/* footer area closed */}
        <div className="topMargin-a">.</div>
        {/* 2nd page and body adre*/}
        <table>
          <thead>
            <div style={{ marginBottom: "20px" }}>
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    background: "#fff",
                    offset: "",
                  }}
                >
                  <div style={{ width: "80%", textAlign: "left", padding: 15 }}>
                    <h3>
                      <img src={logo} alt="logo" style={{ width: "180px" }} />
                    </h3>
                  </div>
                  <div style={{ width: "20%", padding: 15 }}>
                    <h3>
                      <img
                        src={AllergyLogo}
                        alt="logo"
                        style={{ width: "180px", height: "70px" }}
                      />
                    </h3>
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "95%",
                  display: "flex",
                  background: "#fff",
                  border: "1px solid rgb(28, 78, 128)",
                  borderRadius: "10px",
                  marginLeft: "20px",
                }}
                className="marginLeft-a"
              >
                <div
                  style={{
                    padding: "20",
                    marginTop: "10px",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                  className="marginLeft-a"
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      margin: "10px 0px",
                      textAlign: "start",
                    }}
                  >
                    <div style={{ width: "10%", marginLeft: 8 }}>
                      Patient Name:
                    </div>
                    <div style={{ width: "20%", marginLeft: 8 }}>
                      : {alergyData[0]?.designation}&nbsp;
                      {alergyData[0]?.customer_name}
                    </div>
                    <div style={{ width: "10%", marginLeft: 8 }}>
                      Barcode No
                    </div>
                    <div style={{ width: "20%", marginLeft: 8 }}>
                      : {alergyData[0]?.barcode}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      margin: "10px 0px",
                      textAlign: "start",
                    }}
                  >
                    <div style={{ width: "10%", marginLeft: 8 }}>
                      Age/Gender
                    </div>
                    <div style={{ width: "20%", marginLeft: 15 }}>
                      : {alergyData[0]?.customer_age}Y/
                      {alergyData[0]?.customer_gender}
                    </div>
                    <div style={{ width: "10%", marginLeft: 22 }}>Lab No</div>
                    <div style={{ width: "20%", marginLeft: 14 }}>
                      : {alergyData[0]?.pk}
                    </div>
                    <div
                      style={{
                        width: "40%",
                        marginLeft: 8,
                        marginTop: "-30px",
                      }}
                    >
                      <Barcode
                        displayValue={false}
                        height={45}
                        marginLeft={70}
                        value={alergyData[0]?.barcode}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </thead>
          <tbody>
            <div>
              {/* Vegitables */}

              {vegitables &&
                vegitables.length > 0 &&
                (paraCode.some((code: any) =>
                  vegitables.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      {/* first row */}
                      <p>Normal value for all allergens is &lt;0.36 IU/mL</p>
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        VEGETABLES
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {vegitables &&
                            vegitables?.length > 0 &&
                            vegitables?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updatevegData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* fruits */}
              {fruitsData &&
                fruitsData.length > 0 &&
                (paraCode.some((code: any) =>
                  fruitsData.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      {/* first row */}
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        FRUITS
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {fruitsData &&
                            fruitsData?.length > 0 &&
                            fruitsData?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateFruitsData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/*Dry fruits */}
              {dryfruitsData &&
                dryfruitsData.length > 0 &&
                (paraCode.some((code: any) =>
                  dryfruitsData.some(
                    (list: any) => list.parameter_code === code
                  )
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      {/* first row */}
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        DRY FRUITS
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {dryfruitsData &&
                            dryfruitsData?.length > 0 &&
                            dryfruitsData?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateDryFruitData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* SPICES*/}
              {spicesList &&
                spicesList.length > 0 &&
                (paraCode.some((code: any) =>
                  spicesList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        SPICES
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {spicesList &&
                            spicesList?.length > 0 &&
                            spicesList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateSpicesData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}

              {/* CEREALS first row */}
              {cerealsList &&
                cerealsList.length > 0 &&
                (paraCode.some((code: any) =>
                  cerealsList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        CEREALS
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {cerealsList &&
                            cerealsList?.length > 0 &&
                            cerealsList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateCerealsData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}

              {/* PULSES / DAL first row */}
              {pulse &&
                pulse.length > 0 &&
                (paraCode.some((code: any) =>
                  pulse.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        PULSES / DAL
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {pulse &&
                            pulse?.length > 0 &&
                            pulse?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updatePulsesData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}

              {/* SEEDS OIL first row */}
              {seeds &&
                seeds.length > 0 &&
                (paraCode.some((code: any) =>
                  seeds.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        SEEDS OIL
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {seeds &&
                            seeds?.length > 0 &&
                            seeds?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateSeedsData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}

              {/* BEVERAGES first row */}
              {beveragesList &&
                beveragesList.length > 0 &&
                (paraCode.some((code: any) =>
                  beveragesList.some(
                    (list: any) => list.parameter_code === code
                  )
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        BEVERAGES
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {beveragesList &&
                            beveragesList?.length > 0 &&
                            beveragesList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateBeveragesData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* DAIRY first row */}
              {dairyList &&
                dairyList.length > 0 &&
                (paraCode.some((code: any) =>
                  dairyList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        DAIRY
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {dairyList &&
                            dairyList?.length > 0 &&
                            dairyList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateDairyData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* OTHERS first row */}
              {othersList &&
                othersList.length > 0 &&
                (paraCode.some((code: any) =>
                  othersList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        OTHERS
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {othersList &&
                            othersList?.length > 0 &&
                            othersList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateOthersData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}

              {/* SEA FOOD first row */}
              {seafoodsList &&
                seafoodsList.length > 0 &&
                (paraCode.some((code: any) =>
                  seafoodsList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        SEA FOOD
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {seafoodsList &&
                            seafoodsList?.length > 0 &&
                            seafoodsList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateSeaFoodData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* Meat first row */}
              {meat &&
                meat.length > 0 &&
                (paraCode.some((code: any) =>
                  meat.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        MEAT
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {meat &&
                            meat?.length > 0 &&
                            meat?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateMeatData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}

              {/* ANIMALS first row */}
              {animalsImg &&
                animalsImg.length > 0 &&
                (paraCode.some((code: any) =>
                  animalsImg.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        ANIMALS
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {animalsImg &&
                            animalsImg?.length > 0 &&
                            animalsImg?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateAnimalsData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* GRASSES first row */}
              {grassesList &&
                grassesList.length > 0 &&
                (paraCode.some((code: any) =>
                  grassesList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        GRASSES
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {grassesList &&
                            grassesList?.length > 0 &&
                            grassesList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateGrassesData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}

              {/* INSECTS first row */}
              {insectsList &&
                insectsList.length > 0 &&
                (paraCode.some((code: any) =>
                  insectsList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        INSECTS
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {insectsList &&
                            insectsList?.length > 0 &&
                            insectsList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateInsectsData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/*WEED*/}
              {weedsList &&
                weedsList.length > 0 &&
                (paraCode.some((code: any) =>
                  weedsList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        WEED
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {weedsList &&
                            weedsList?.length > 0 &&
                            weedsList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateWeedData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/*DUST MITES*/}
              {dustmitesList &&
                dustmitesList.length > 0 &&
                (paraCode.some((code: any) =>
                  dustmitesList.some(
                    (list: any) => list.parameter_code === code
                  )
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        DUST MITES
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {dustmitesList &&
                            dustmitesList?.length > 0 &&
                            dustmitesList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateDustMitesData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/*MOULDS & YEAST*/}
              {mouldsList &&
                mouldsList.length > 0 &&
                (paraCode.some((code: any) =>
                  mouldsList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        MOULDS & YEAST
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {mouldsList &&
                            mouldsList?.length > 0 &&
                            mouldsList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateMouldsData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* DUSTS  */}
              {dustList &&
                dustList.length > 0 &&
                (paraCode.some((code: any) =>
                  dustList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        DUSTS
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {dustList &&
                            dustList?.length > 0 &&
                            dustList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateDustData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* SKIN CONTACT  */}
              {skinList &&
                skinList.length > 0 &&
                (paraCode.some((code: any) =>
                  skinList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        SKIN CONTACT
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {skinList &&
                            skinList?.length > 0 &&
                            skinList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateSkinData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* PARASITE  */}
              {parasiteList &&
                parasiteList.length > 0 &&
                (paraCode.some((code: any) =>
                  parasiteList.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        PARASITE
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {parasiteList &&
                            parasiteList?.length > 0 &&
                            parasiteList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateParasiteData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}

              {/* ANTIBIOTICS  */}
              {antibioticsList &&
                antibioticsList.length > 0 &&
                (paraCode.some((code: any) =>
                  antibioticsList.some(
                    (list: any) => list.parameter_code === code
                  )
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        ANTIBIOTICS
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {antibioticsList &&
                            antibioticsList?.length > 0 &&
                            antibioticsList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateAntiBiotics(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}

              {/* PAINKILLER  */}
              {painKillerList &&
                painKillerList.length > 0 &&
                (paraCode.some((code: any) =>
                  painKillerList.some(
                    (list: any) => list.parameter_code === code
                  )
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        PAINKILLER
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {painKillerList &&
                            painKillerList?.length > 0 &&
                            painKillerList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updatePainKillerData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* MULTIVITAMIN  */}
              {multivitaminList &&
                multivitaminList.length > 0 &&
                (paraCode.some((code: any) =>
                  multivitaminList.some(
                    (list: any) => list.parameter_code === code
                  )
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        MULTIVITAMIN
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {multivitaminList &&
                            multivitaminList?.length > 0 &&
                            multivitaminList?.map(
                              (list: any, index: number) => {
                                if (paraCode.includes(list.parameter_code)) {
                                  return (
                                    <div className="table-row">
                                      <img
                                        alt="description of image"
                                        className="image"
                                        src={list?.parameter_url}
                                        style={{ marginLeft: "15px" }}
                                      />
                                      <div
                                        className="table-cell"
                                        style={{ textAlign: "center" }}
                                      >
                                        {list?.parameter_name}
                                      </div>
                                      <input
                                        style={{
                                          border: "none",
                                          textAlign: "left",
                                          width: "50px",
                                          fontWeight:
                                            list?.parameter_value > 0.36
                                              ? "bold"
                                              : "normal",
                                        }}
                                        value={list?.parameter_value}
                                        onChange={(e) =>
                                          updateMultiVitamin(
                                            list?.id,
                                            e.target.value,
                                            index,
                                            "free_text",
                                            list
                                          )
                                        }
                                      />
                                    </div>
                                  );
                                }
                                return null;
                              }
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* ANESTHESIA  */}
              {anesthesiaList &&
                anesthesiaList.length > 0 &&
                (paraCode.some((code: any) =>
                  anesthesiaList.some(
                    (list: any) => list.parameter_code === code
                  )
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        ANESTHESIA
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {anesthesiaList &&
                            anesthesiaList?.length > 0 &&
                            anesthesiaList?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateAnesthesiaData(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* Others1  */}
              {others1List &&
                others1List.length > 0 &&
                (paraCode.some((code: any) =>
                  others1List.some((list: any) => list.parameter_code === code)
                ) ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      maxHeight: "600px",
                      overflow: "auto",
                      display: "flex",
                      gap: "14px",
                      pageBreakInside: "avoid",
                      marginTop: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        display: "table-cell",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "20px",
                          borderRadius: "0px 10px",
                          backgroundColor: "rgb(28, 78, 128)",
                          textAlign: "center",
                          borderRight: "4px solid #6b055e",
                          marginTop: "20px",
                          width: "210px",
                        }}
                        className="box-a marginLeft-a"
                      >
                        OTHERS
                      </div>
                      <div>
                        <div className="parent-container marginLeft-a">
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableHead
                            style={{
                              backgroundColor: "#dcd7d7",
                              display: "inline-table",
                            }}
                          >
                            <TableRow>
                              <TableCell align="left">Image</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="right">Value (IU/mL)</TableCell>
                            </TableRow>
                          </TableHead>
                        </div>
                        <div className="table-body parent-container marginLeft-a">
                          {others1List &&
                            others1List?.length > 0 &&
                            others1List?.map((list: any, index: number) => {
                              if (paraCode.includes(list.parameter_code)) {
                                return (
                                  <div className="table-row">
                                    <img
                                      alt="description of image"
                                      className="image"
                                      src={list?.parameter_url}
                                      style={{ marginLeft: "15px" }}
                                    />
                                    <div
                                      className="table-cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      {list?.parameter_name}
                                    </div>
                                    <input
                                      style={{
                                        border: "none",
                                        textAlign: "left",
                                        width: "50px",
                                        fontWeight:
                                          list?.parameter_value > 0.36
                                            ? "bold"
                                            : "normal",
                                      }}
                                      value={list?.parameter_value}
                                      onChange={(e) =>
                                        updateOthers1(
                                          list?.id,
                                          e.target.value,
                                          index,
                                          "free_text",
                                          list
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              {/* <div className="topMargin-a">.</div> */}
              <div style={{ pageBreakBefore: "always" }}>.</div>
              <div>
                <img
                  src={Allergy_new}
                  alt="logo"
                  style={{ width: "80%", margin: "2px", marginLeft: "25px" }}
                />{" "}
              </div>

              <div
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderRadius: "0px 10px",
                  backgroundColor: "rgb(28, 78, 128)",
                  width: "270px",
                  height: "25px",
                  textAlign: "center",
                  borderRight: "4px solid #6b055e",
                }}
                className="box-a marginLeft-a"
              >
                Interpretation
              </div>
              <div
                className="marginLeft-a"
                style={{ marginTop: "10px", fontSize: "14px" }}
              >
                <p>
                  IgE takes part in occurrence and progress of allergic
                  reactions. On binding allergens, these antibodies obtain an
                  ability to initiate release of a range of vasoactive
                  substances from leukocytes, which deﬁne development of
                  allergic symptoms.Deﬁnition and quantitative measurement of
                  free allergen-speciﬁc IgE concentration have a great
                  importance for diagnosis of allergic diseases and selection of
                  an adequate therapy. Assay results need to be correlated
                  clinically
                </p>
              </div>

              <div
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderRadius: "0px 10px",
                  backgroundColor: "rgb(28, 78, 128)",
                  width: "270px",
                  height: "25px",
                  textAlign: "center",
                  borderRight: "4px solid #6b055e",
                }}
                className="box-a marginLeft-a"
              >
                Limitation of the Test
              </div>
              <div
                className="marginLeft-a"
                style={{ marginTop: "10px", fontSize: "14px" }}
              >
                <p>
                  The Serum specific IgE levels performed using different
                  assays/ platforms may not be comparable owing to the
                  difference in the diagnostic sensitivity &amp; specificity. It
                  is always advisable to consult an allergy specialist. In case
                  the results are found not to be correlating with the clinical
                  history, further testing by Gold standard technique
                  (ImmunoCAP) is recommended. Clinical correlation is advisable
                  in class 0 and class 1 IgE antibodies detection.
                  <br /><br/>
                  Normal levels of IgE do not rule out possibility of IgE
                  dependent allergies as the diagnostic sensitivity of the test
                  depends upon elapsed time between exposure to an allergen and
                  testing, patient age and affected target organs. No close
                  correlation has been demonstrated between severity of allergic
                  reaction and IgE levels.
                  <br /><br/>
                  The presence of a small amount of IgE antibody or
                  cross-reactivity of allergens may result in false positive
                  results.This can occur as certain allergens can exhibit common
                  antigenic determinants leading to antibodies binding other
                  similar allergens. This cross reactivity among different
                  allergens can be observed in allergens like birch pollen,
                  nuts, meadow grass, tomato, ambrosia, melon etc. These false
                  positive results are usually of Class 0 and 1.
                  <br /><br/>
                  Intake of Antihistaminic Drugs may result in false Negative
                  results. It is usually advised to avoid intake of such
                  medications seven days prior to collection of sample.
                  <br /><br/>
                  A negative result against antibiotics (penicillin G,
                  penicillin V, cephalosporin, ampicillin and amoxicillin)
                  doesn’t exclude presence of a clinical hypersensitivity to
                  these allergens. This result can be explained by initiation of
                  the allergic reaction that takes place without participation
                  of IgE antibodies or a wrong choice of blood sampling time
                  (before the increase of specific IgE concentration in blood or
                  after their concentration decreases).
                  <br /><br/>
                  Similarly, a negative result to other medications can be
                  observed due non immediate drug hypersensitivity reactions
                  which generally involve IgG antibody and T cells. Other
                  reasons include, excessive inhibition of specific enzymes or
                  off-target occupation of (nonimmune) receptors like
                  hypersensitivity to nonsteroidal anti- inflammatory drugs
                  (NSAIDs) has been related to the inhibition of COX-1 enzyme.
                  <br /><br/>
                  A negative result of specific IgE assay against food-borne
                  allergens and bites of venomous insects doesn’t exclude
                  possibility of occurrence of allergy to these allergens.
                  <br /><br/>
                  False-negative results of skin prick and/or blood-specific IgE
                  allergy testing occur in some individuals in the weeks
                  following some anaphylactic reactions. This phenomenon has
                  been referred to by many names, including refractory period,
                  empty mast cell syndrome, tachyphylaxis, and postanaphylaxis
                  mast cell anergy (PAMA). PAMA has been proposed to involve
                  transient depletion of mast cell mediators and diminished mast
                  cell sensitivity
                  <br /><br/>
                  A negative result of specific IgE assay against allergens can
                  be observed if that particular food is avoided for long.
                  <br /><br/>
                  In cases of food allergy, specific IgE antibodies may be
                  undetectable in-spite of a convincing clinical history. This
                  is observed as antibodies formed may be directed towards
                  allergens that are now revealed or altered, due to industrial
                  food processing, cooking or digestion and therefore do not
                  exist in the original food for which the patient is tested.
                  Eg- individual allergic to egg but not allergic to cake with
                  egg- eggs are processed in preparing cake causing change of
                  texture and thus allergens might not be recoganised.
                  <br /><br/>
                  If concentration of total IgE in blood serum is higher than
                  1000 IU/mL,measured concentrations of allergen-specific IgE
                  may be slightly lower than the real values.
                </p>
              </div>
              <div style={{ padding: "20" }}>
                <div
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "20px",
                    borderRadius: "0px 10px",
                    backgroundColor: "rgb(28, 78, 128)",
                    width: "270px",
                    height: "25px",
                    textAlign: "center",
                    borderRight: "4px solid #6b055e",
                  }}
                  className="box-a marginLeft-a"
                >
                  Condition Of Reporting
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    background: "#fff",
                    padding: "25px",
                  }}
                >
                  <ul>
                    <li>
                      It is Presumed that specimen belongs to patient named or
                      identified, such verification being carried out at the
                      point of generation of said specimen{" "}
                    </li>
                    <li>
                      A test might not be performed due to following reason
                    </li>
                    - Specimen Quantity not sufficient (Inadequate
                    collection/spillage during transit)
                    <br />
                    - Specimen Quality not acceptable
                    (Hemolysis/clotted/lipemic.)
                    <br />
                    - Incorrect sample type
                    <br />
                    - Test cancelled either on request of patient or doctor
                    <br />
                    In any of the above case a fresh specimen will be required
                    for testing and reporting
                    <br />
                    <li>
                      {" "}
                      The results of the tests may vary from lab to lab ; time
                      to time for the same patient{" "}
                    </li>
                    <li>
                      {" "}
                      The reported results are dependent on individual assay
                      methods, equipment, method sensitivity, specificity and
                      quality of the specimen received
                    </li>
                    <li>Partial representation of report is not allowed</li>
                    <li>
                      The reported tests are for the notification of the
                      referring doctor, only to assist him/her in the diagnosis
                      and management of the patient
                    </li>
                    <li>
                      lf Sample collection date is not stated on test
                      requisition form, the current date will be printed by
                      default as the date of collection.
                    </li>
                    <li>
                      Report with status “Preliminary” means one or more test
                      are yet to be reported
                    </li>
                    <li>This report is not valid for Medico Legal Purpose</li>
                    <li>
                      Applicable Jurisdiction will be of “Delhi” for any
                      dispute/claim concerning the test(s) & results of the test
                      (s)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </tbody>
        </table>
        {/* doctorlist  */}
        <div style={{ padding: "20", marginTop: "-50px" }}>
          <div style={{ padding: "20px" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                background: "#fff",
              }}
            >
              <div
                style={{ width: "75%", textAlign: "left", padding: 15 }}
              ></div>
              <div style={{ width: "25%", textAlign: "left", padding: 15 }}>
                <img
                  src={
                    "https://static-redcliffelabs.s3.amazonaws.com/media/gallary-images/None/c2e5461c-8ace-4da7-ae72-525374c4ac28.jpg"
                  }
                  alt="logo"
                  style={{ width: "60%" }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* footer section starting */}
        <div>
          {/* footer area */}
          <div style={{ padding: "20px", marginTop: "-70px" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                background: "#fff",
              }}
            >
              <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                <h3>
                  <QRCode
                    value={`https://lead.redcliffelabs.com/verify-report/?booking=${alergyData[0]?.uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`}
                    size={115}
                  />
                </h3>
              </div>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  padding: 10,
                  marginTop: "-3px",
                }}
              >
                {alergyData[0]?.booking_type === "b2b" ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      margin: "10px 0px",
                      marginTop: "9px",
                    }}
                  >
                    <div style={{ width: "33%", marginLeft: 8 }}>
                      <img
                        src={callIcon}
                        alt="logo"
                        style={{ width: "20px", margin: "2px" }}
                      />{" "}
                      <span style={{ color: "red" }}>928-909-0609</span>
                    </div>
                    <div style={{ width: "33%", marginLeft: 8 }}>
                      <img
                        src={maillIcon}
                        alt="logo"
                        style={{ width: "20px", margin: "2px" }}
                      />
                      <span style={{ color: "red" }}>
                        ccsupport@redcliffelabs.com
                      </span>
                    </div>
                    <div style={{ width: "33%", marginLeft: 8 }}>
                      <img
                        src={browserIcon}
                        alt="logo"
                        style={{ width: "20px", margin: "2px" }}
                      />
                      <span style={{ color: "red" }}>
                        www.redcliffelabs.com
                      </span>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      margin: "10px 0px",
                      marginTop: "9px",
                    }}
                  >
                    <div style={{ width: "33%", marginLeft: 8 }}>
                      <img
                        src={callIcon}
                        alt="logo"
                        style={{ width: "20px", margin: "2px" }}
                      />{" "}
                      <span style={{ color: "red" }}>898-898-0606</span>
                    </div>
                    <div style={{ width: "33%", marginLeft: 8 }}>
                      <img
                        src={maillIcon}
                        alt="logo"
                        style={{ width: "20px", margin: "2px" }}
                      />
                      <span style={{ color: "red" }}>
                        care@redcliffelabs.com
                      </span>
                    </div>
                    <div style={{ width: "33%", marginLeft: 8 }}>
                      <img
                        src={browserIcon}
                        alt="logo"
                        style={{ width: "20px", margin: "2px" }}
                      />
                      <span style={{ color: "red" }}>
                        www.redcliffelabs.com
                      </span>
                    </div>
                  </div>
                )}

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "10px 0px",
                    textAlign: "left",
                    marginBottom: "-15px",
                  }}
                >
                  <h6 style={{ marginLeft: "16px" }}>
                    {" "}
                    Redcliffe Lifetech Private Limited, H-31, Sector-63, Noida,
                    Uttar Pradesh, 201301
                  </h6>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "10px 0px",
                    marginLeft: "16px",
                    textAlign: "left",
                  }}
                >
                  <p style={{ fontSize: "13px", marginTop: "3px" }}>
                    {" "}
                    All Lab are subjected to clinical interpretations by
                    qualified medical professional and this report is not
                    subject to use for any medico-legal purpose.
                  </p>
                </div>
                <hr
                  style={{
                    backgroundColor: "red",
                    width: "100%",
                    height: "8px",
                    marginTop: "10px",
                  }}
                />
              </div>
            </div>
            {/* second page  */}
          </div>
          {/* footer area closed */}
        </div>
        {/* footer section end */}
      </div>

      {/* last Page */}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  reportListParameter: state.LimsAdminReducer.reportListParameter,
  updatedReportData: state.LimsAdminReducer.updatedReportData,
  fetchAlleryReport: state.LimsAdminReducer.fetchAlleryReport,
});

export default connect(mapStateToProps, {
  getReportTemplateParameter,
  createNewReport,
  getUpdatedCustomerReportData,
  updateReport,
  getAllergyPackage,
})(NbsReport);
